import { render, staticRenderFns } from "./PlainButton.vue?vue&type=template&id=1d1c2ad7&scoped=true&"
import script from "./PlainButton.vue?vue&type=script&lang=js&"
export * from "./PlainButton.vue?vue&type=script&lang=js&"
import style0 from "./PlainButton.vue?vue&type=style&index=0&id=1d1c2ad7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c2ad7",
  null
  
)

export default component.exports